var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNatomaLogoLight = function SvgNatomaLogoLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#natoma-logo-light_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "#95FDA7",
    rx: 48
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E1F1D",
    fillRule: "evenodd",
    d: "M51.75 33.5a8.25 8.25 0 0 0-8.25 8.25V74.5h-15V41.75c0-12.84 10.41-23.25 23.25-23.25S75 28.91 75 41.75v21.5a3.75 3.75 0 1 0 7.5 0V42c0-12.979 10.521-23.5 23.5-23.5h8.5v15H106a8.5 8.5 0 0 0-8.5 8.5v21.25C97.5 73.605 89.105 82 78.75 82S60 73.605 60 63.25v-21.5a8.25 8.25 0 0 0-8.25-8.25",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "natoma-logo-light_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "#fff",
    rx: 48
  })))));
};
export default SvgNatomaLogoLight;